import { Component, HostListener, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';

import { CourseLectureStatus } from '../../shared/base/course-lecture-status';
import { DialogButtonBase } from '../../shared/base/dialog-button-base';
import { QuestionBase } from '../../shared/dynamic-form/shared/question-base';
import { SelectQuestion } from '../../shared/dynamic-form/shared/question-select';
import { TextAreaQuestion } from '../../shared/dynamic-form/shared/question-textarea';
import { TextboxQuestion } from '../../shared/dynamic-form/shared/question-textbox';
import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from '../../shared/message';
import { Course } from '../shared/course';
import { CourseService } from '../shared/course.service';

@Component({
  selector: 'app-course-edit-button',
  template: '<ng-content></ng-content>'
})
export class CourseEditButtonComponent extends DialogButtonBase {
  @Input() course: Course;

  constructor(dialog: MatDialog, snackBar: MatSnackBar, private service: CourseService) {
    super(dialog, snackBar);
  }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  openDialog(): void {
    super.openDialog(this.title, this.questions, { width: '600px' });
  }

  async onSubmit(value: Course): Promise<any> {
    try {
      await this.service.update(this.course.$key, value);
      this.closeDialog();
      this.openSnackBar(MESSAGE_EDIT_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  private get title(): string {
    return '강좌 편집';
  }

  private get questions(): Array<QuestionBase<any>> {
    return [
      new TextboxQuestion({
        key: 'name',
        label: '제목',
        value: this.course.name,
        required: true
      }),
      new TextboxQuestion({
        key: 'coverUrl',
        label: 'cover url',
        value: this.course.coverUrl
      }),
      new SelectQuestion({
        key: 'status',
        label: '상태',
        required: true,
      }, CourseLectureStatus.getOptions(this.course.status)),
      new TextboxQuestion({
        key: 'slackUrl',
        label: 'slack url',
        value: this.course.slackUrl
      }),
      new TextAreaQuestion({
        key: 'description',
        label: '간략한 설명',
        value: this.course.description
      })
    ];
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-edit-button/course-edit-button.component.ts